module.exports = __webpack_public_path__ + "static/media/login.c8b5353b.png";